export interface ITrackFile {
    fileName?: string | null;
    numberOfRecords?: string | null;
}
export class TrackFile {
    public fileName!: string | null;
    public numberOfRecords!: string | null;

    constructor(trackFile: ITrackFile) {
        this.fileName = trackFile.fileName || null;
        this.numberOfRecords = trackFile.numberOfRecords || null;
    }
    public static empty() {
        return new TrackFile({});
    }

}